import { Building2, Paintbrush, ChefHat, Hammer, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Reveal from "@/components/Reveal";

const services = [
  {
    slug: "civil-work",
    icon: Building2,
    title: "Civil Work",
    text: "Professional civil construction and execution including masonry, plastering, flooring and related civil work.",
  },
  {
    slug: "interior-work",
    icon: Paintbrush,
    title: "Interior Work",
    text: "Modern interior execution focused on functionality, quality finishing and elegant design.",
  },
  {
    slug: "modular-kitchen",
    icon: ChefHat,
    title: "Modular Kitchen",
    text: "Contemporary modular kitchens with smart storage, practical layouts, quality finishes and professional installation.",
  },
  {
    slug: "restoration-renovation",
    icon: Hammer,
    title: "Restoration & Renovation",
    text: "Renovation, restoration, repair and modernization of existing homes and spaces.",
  },
];

export default function Services() {
  const navigate = useNavigate();
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-zinc-50 border-y border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl mb-16">
          <p className="text-xs tracking-[0.25em] uppercase font-semibold text-zinc-500 mb-5">02 &middot; What We Do</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-zinc-950">
            Our Services
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08} className="h-full">
            <div
              data-testid={`service-card-${s.title.toLowerCase().replace(/[\s&]+/g, "-")}`}
              className="group h-full bg-white border border-zinc-200 rounded-sm p-8 flex flex-col hover:border-zinc-950 transition-colors duration-300"
            >
              <s.icon className="w-8 h-8 text-zinc-950" strokeWidth={1.25} />
              <h3 className="mt-8 font-heading text-xl font-medium text-zinc-950">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-600 flex-1">{s.text}</p>
              <button
                data-testid={`service-explore-${s.title.toLowerCase().replace(/[\s&]+/g, "-")}`}
                onClick={() => navigate(`/services/${s.slug}`)}
                className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-zinc-950 group-hover:gap-3 transition-all duration-300"
              >
                Explore Service <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
              </button>
            </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
